import {eventChannel} from 'redux-saga';
import {put, call, take, fork} from 'redux-saga/effects';
import {
  MQTT_CONNECTED,
  MQTT_OFFILNE,
  MQTT_RECONNECT,
  MQTT_CLOSE,
  MQTT_SUBCRIBE_TOPIC,
  MQTT_UNSUBCRIBE_TOPIC,
  //MQTT_MESSAGE_RECEIVED,
  MQTT_DEVICE_STATUS_RECEIVED,
  MQTT_NEW_EVENT_RECEIVED,
  MQTT_NEW_CONFIG_RECEIVED,
  MQTT_NEW_ALARM_STATE_RECEIVE,
  MQTT_STATION_CONNECTION_STATUS_RECEIVE
} from '../actions/constants'

import {SOCKET_MSG_TYPE_STATION_CONNECTION_STATUS, SOCKET_MSG_TYPE_NEW_ALARM_STATE, SOCKET_MSG_TYPE_NEW_EVENT, SOCKET_MSG_TYPE_NEW_STATUS, SOCKET_MSG_TYPE_NEW_CONFIG} from '../constants/defaultValues'

//const getTopicsFromState = (state) => state.mqtt.topics

function* createEventMqttChannel({mqttClient}) {
  return yield eventChannel(emit => {
    mqttClient.on('connect', () => {
      emit(MQTT_CONNECTED)
    });
    mqttClient.on('offline', () => {
      emit(MQTT_OFFILNE)
    });
    mqttClient.on('close', () => {
      emit(MQTT_CLOSE)
    });
    mqttClient.on('reconnect', () => {
      emit(MQTT_RECONNECT)
    });
    mqttClient.on('message', (topic, message) => {
      emit({topic, message})
    });
    return() => {
      mqttClient.end();
    };
  });
}

export function* watchSubcribeTopic({mqttClient}) {
  while (true) {
    //yield take(MQTT_CONNECTED)
    const {newTopicState} = yield take(MQTT_SUBCRIBE_TOPIC)
    mqttClient.subscribe(newTopicState, null, (err, granted) => {})
  }
}

export function* watchUnsubcribeTopic({mqttClient}) {
  while (true) {
    const {newTopicState} = yield take(MQTT_UNSUBCRIBE_TOPIC)
    if (newTopicState.length > 0) {
      mqttClient.unsubscribe(newTopicState)
    }
  }
}

function* processPayload({payload}) {
  const json = JSON.parse(payload.toString());
  const jStation = JSON.parse(atob(json.Data));
  switch (json.Type) {
    case SOCKET_MSG_TYPE_STATION_CONNECTION_STATUS:
      const jConnection = JSON.parse(atob(jStation.Data));
      const connection = {
        ID: jStation.StationID,
        OnlineState: jConnection.Option === 1
          ? 0
          : 1,
        AlarmLevel: jConnection.AlarmLevel,
        OnlineTime: jConnection.Time
      }
      yield put({type: MQTT_STATION_CONNECTION_STATUS_RECEIVE, newConnectionState: connection})
      break;
    case SOCKET_MSG_TYPE_NEW_ALARM_STATE:
      const jAlarm = JSON.parse(atob(jStation.Data))
      const alarm = {
        ID: jStation.StationID,
        AlarmLevel: jAlarm.AlarmLevel,
        AlarmCount: jAlarm.AlarmCount,
        AlarmList: jAlarm.AlarmList
      };
      yield put({type: MQTT_NEW_ALARM_STATE_RECEIVE, newAlarmState: alarm})
      break;
    case SOCKET_MSG_TYPE_NEW_EVENT:
      const jEvents = JSON.parse(atob(jStation.Data));
      yield put({type: MQTT_NEW_EVENT_RECEIVED, newEventsState: jEvents})
      break;
    case SOCKET_MSG_TYPE_NEW_STATUS:
      const jDevicesStatus = JSON.parse(atob(jStation.Data));
      yield put({type: MQTT_DEVICE_STATUS_RECEIVED, newDeviceStatusState: jDevicesStatus})
      break;
    case SOCKET_MSG_TYPE_NEW_CONFIG:
      const jConfigs = JSON.parse(atob(jStation.Data));
      yield put({type: MQTT_NEW_CONFIG_RECEIVED, newDeviceStatusState: jConfigs})
      break;
    default:
      break;
  }
}

export function* watchHandleMessage({mqttClient}) {
  const mqttMessage = yield call(createEventMqttChannel, {mqttClient})
  while (true) {
    const message = yield take(mqttMessage)
    if (message.topic) {
      const payload = message.message
      yield fork(processPayload, {payload})
    } else {
      if (message === MQTT_CONNECTED) {
        yield put({type: MQTT_CONNECTED})
      }
      if (message === MQTT_RECONNECT) {}
      if (message === MQTT_OFFILNE) {
        yield put({type: MQTT_OFFILNE})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/mqtt.js